//code from https://blog.logrocket.com/implementing-copy-clipboard-react-clipboard-api/
//Should not be used outside of the context of a button or interactable element
export async function copyTextToClipboard(text: string) {
    if ('clipboard' in navigator) {
        return navigator.clipboard.writeText(text)
    }
    return document.execCommand('copy', true, text)
}
